import {call, put} from "redux-saga/effects";
import { setProductDetails } from "../actions";
import {getProductInformation} from "../../firebase/methods";


const requestGetProductDetails = () => {
    return getProductInformation();
}

export function* handleGetProductDetails(action){
    try {
        const response = yield call(requestGetProductDetails);
        let data = undefined;
        response.docs.forEach(doc => {
            data = doc.data();
        });
        yield put(setProductDetails(data));
    }
    catch (error) {
        console.log(error)
    }
}